import styled from "styled-components";

const RootContainer = styled.div`
  background-color: rgb(245, 245, 245);
  text-align: center;
  height: 100vh;
`;

const HeaderContainer = styled.div`
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
`;

const HeaderCloseButtonContainer = styled.div`
  position: absolute;
  left: 10px;
  :hover {
    cursor: pointer;
  }
`;

const HeaderTitle = styled.span`
  font-size: 18px;
  font-weight: bold;
  text-align: center;
`;

const SummaryContainer = styled.div`
  border-radius: 8px;
  background-color: rgb(245, 245, 245);
  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

const BackToStoreButton = styled.button`
  border: 2px solid black;
  background: black;
  color: white;
  outline: none;
  width: 200px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 8px;
`;

const modules = {
  RootContainer,
  HeaderContainer,
  HeaderCloseButtonContainer,
  HeaderTitle,
  SummaryContainer,
  BackToStoreButton,
};

export default modules;
